import { render } from "./ProjectTools.vue?vue&type=template&id=099b514b&scoped=true"
import script from "./ProjectTools.vue?vue&type=script&lang=js"
export * from "./ProjectTools.vue?vue&type=script&lang=js"

import "./ProjectTools.vue?vue&type=style&index=0&id=099b514b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099b514b"]])

export default __exports__